interface Props {
  numerator: number;
  denominator: number;
}

export const calculateClassAttendance = ({ numerator, denominator }: Props) => {
  return Math.round((numerator / denominator) * 100);
};
